'use strict';

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _dec2, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shared = require('./shared');

var _Icon = require('../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LabelList = require('../components/LabelList');

var _LabelList2 = _interopRequireDefault(_LabelList);

var _LabelDropdown = require('../components/LabelDropdown');

var _LabelDropdown2 = _interopRequireDefault(_LabelDropdown);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%'
    },
    heading: {
      display: 'flex',
      textAlign: 'left'
    },
    entities: {
      lineHeight: 2,
      padding: 20,
      '& *::selection': {
        background: theme.bgHighlight
      },
      '& *::-moz-selection': {
        background: theme.bgHighlight
      }
    },
    rtl: {
      direction: 'rtl',
      '& $mark': {
        display: 'inline-block',
        padding: [['0.35em', '0.4em']],
        marginLeft: 2
      },
      '& $remove': {
        left: -7
      }
    },
    token: {
      display: 'inline-block',
      margin: [[0, 1]]
    },
    tokenDisabled: {
      opacity: 0.5,
      userSelect: 'none',
      cursor: 'not-allowed'
    },
    tokenWs: {
      opacity: 0.5,
      fontSize: '0.7em',
      padding: [[0, 10]],
      letterSpacing: 2
    },
    noTrailingWs: {
      whiteSpace: 'normal',
      marginRight: -1
    },
    tokenSpacer: {
      display: 'none'
    },
    mark: {
      position: 'relative',
      cursor: 'pointer',
      '&:hover $remove': {
        opacity: 1
      }
    },
    remove: {
      position: 'absolute',
      top: -7,
      left: -7,
      color: theme.bgCard,
      background: theme.colorText,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '0.9em',
      fontFamily: 'sans-serif',
      lineHeight: 1.1,
      width: 14,
      height: 14,
      textAlign: 'center',
      borderRadius: '50%',
      opacity: 0,
      transition: [['opacity', '0.1s', 'ease']],
      userSelect: 'none',
      zIndex: 10
    },
    addButton: {
      marginLeft: 10
    }
  };
};

var Token = (_dec = (0, _util.withStyles)(styles), _dec(_class = function (_React$Component) {
  _inherits(Token, _React$Component);

  function Token() {
    _classCallCheck(this, Token);

    return _possibleConstructorReturn(this, (Token.__proto__ || Object.getPrototypeOf(Token)).apply(this, arguments));
  }

  _createClass(Token, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          id = _props.id,
          text = _props.text,
          _props$ws = _props.ws,
          ws = _props$ws === undefined ? true : _props$ws,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          _props$hideNewlines = _props.hideNewlines,
          hideNewlines = _props$hideNewlines === undefined ? false : _props$hideNewlines,
          _props$allowNewlineHi = _props.allowNewlineHighlight,
          allowNewlineHighlight = _props$allowNewlineHi === undefined ? false : _props$allowNewlineHi,
          _props$honorWs = _props.honorWs,
          honorWs = _props$honorWs === undefined ? false : _props$honorWs,
          classes = _props.classes;
      var whitespaceOnly = !/\S/.test(text);
      var newlineOnly = /^[\n\s]*$/.test(text);
      var isDisabled = disabled || !allowNewlineHighlight && newlineOnly;
      var noTrailingWs = honorWs && !ws;
      var tokenClasses = (0, _classnames2["default"])(classes.token, (_classNames = {}, _defineProperty(_classNames, classes.tokenDisabled, isDisabled), _defineProperty(_classNames, classes.tokenWs, whitespaceOnly), _defineProperty(_classNames, classes.noTrailingWs, noTrailingWs), _classNames));
      var newlines = !whitespaceOnly ? [] : text.match(/\n/g) || [];
      var breaks = newlines.map(function (_) {
        return _react2["default"].createElement('br', null);
      }); // important: note the space before </span> (not only for adding a space
      // but also to allow cross-browser highlighting per double click)

      return _react2["default"].createElement(_react.Fragment, {
        key: id
      }, _react2["default"].createElement('span', {
        className: tokenClasses,
        id: id
      }, (0, _util.replaceWs)(text), ' '), !hideNewlines && breaks);
    }
  }]);

  return Token;
}(_react2["default"].Component)) || _class);
var SpansManual = (_dec2 = (0, _util.withStyles)(styles), _dec2(_class2 = (_temp2 = _class3 = function (_React$Component2) {
  _inherits(SpansManual, _React$Component2);

  function SpansManual() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, SpansManual);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = SpansManual.__proto__ || Object.getPrototypeOf(SpansManual)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      selected: [],
      label: '',
      touched: null
    }, _this2.componentDidMount = function () {
      _this2.setState({
        label: _this2.props.config.labels[0]
      });

      _this2.updateSpans(_this2.props.content);
    }, _this2.componentWillReceiveProps = function (_ref2) {
      var content = _ref2.content;

      if (_this2.props.content && _this2.props.content[_constants.TASK_ID] != content[_constants.TASK_ID]) {
        _this2.updateSpans(content);
      }
    }, _this2.updateSpans = function (_ref3) {
      var _ref3$spans = _ref3.spans,
          spans = _ref3$spans === undefined ? [] : _ref3$spans;
      var selected = spans.map(function (_ref4) {
        var token_start = _ref4.token_start,
            token_end = _ref4.token_end,
            label = _ref4.label;
        return {
          start: token_start,
          end: token_end,
          label: label
        };
      }).sort(function (a, b) {
        return a.start - b.start;
      });

      _this2.setState({
        selected: selected
      });
    }, _this2.getSpans = function (_ref5) {
      var tokens = _ref5.tokens;
      return _this2.state.selected.map(function (_ref6) {
        var start = _ref6.start,
            end = _ref6.end,
            label = _ref6.label;
        return {
          start: tokens[start].start,
          end: tokens[end].end,
          token_start: tokens[start].id,
          token_end: tokens[end].id,
          label: label
        };
      });
    }, _this2.handleUpdate = function () {
      return _this2.props.update({
        spans: _this2.getSpans(_this2.props.content)
      });
    }, _this2.handleTouchStart = function (_ref7) {
      var target = _ref7.target;
      if (!target || !target.hasAttribute('id')) return;

      _this2.setState({
        touched: parseInt(target.getAttribute('id'))
      });
    }, _this2.handleTouchEnd = function (_ref8) {
      var changedTouches = _ref8.changedTouches;
      var touched = _this2.state.touched; // the touchEnd event's target doesn't actually expose the element you
      // "land on", but the element it started on – arguably, we could
      // probably get rid of handleTouchStart?

      var target = document.elementFromPoint(changedTouches[0].clientX, changedTouches[0].clientY);
      if (!target || !target.hasAttribute('id') || !touched) return;
      var tokenId = parseInt(target.getAttribute('id'));

      var _sort = [touched, tokenId].sort(function (a, b) {
        return a - b;
      }),
          _sort2 = _slicedToArray(_sort, 2),
          start = _sort2[0],
          end = _sort2[1];

      if (_this2.isValidSelection(start, end)) {
        _this2.updateSelected(start, end);
      }

      _this2.setState({
        touched: null
      });
    }, _this2.handleSelection = function (ev) {
      var selection = window.getSelection();

      if (!selection.isCollapsed) {
        var range = selection.getRangeAt(0);
        var startNode = range.startContainer.parentElement;
        var endNode = range.endContainer.parentElement;
        var start = parseInt(startNode.getAttribute('id'));
        var end = parseInt(endNode.getAttribute('id'));

        if (_this2.props.config.highlightChars) {
          // Adjust selection if invisible whitespace is selected
          if (range.startOffset !== 0) start = start + 1;
          if (range.endOffset !== 1) end = end - 1;
        }

        if (!_this2.isValidSelection(start, end)) {
          selection.removeAllRanges();
          return;
        }

        _this2.updateSelected(start, end);

        selection.removeAllRanges();
      }
    }, _this2.updateSelected = function (start, end) {
      document.dispatchEvent(new CustomEvent('prodigyspanselected', {
        detail: {
          start: start,
          end: end
        }
      }));

      _this2.setState(function (prevState) {
        return {
          selected: [].concat(_toConsumableArray(prevState.selected), [{
            start: start,
            end: end,
            label: _this2.state.label
          }]).sort(function (a, b) {
            return a.start - b.start;
          })
        };
      }, _this2.handleUpdate);
    }, _this2.handleDeletion = function (tokens) {
      var startToken = tokens[0].id;
      var endToken = tokens[tokens.length - 1].id;

      _this2.setState(function (prevState) {
        return {
          selected: prevState.selected.filter(function (_ref9) {
            var start = _ref9.start,
                end = _ref9.end;
            return start != startToken && end != endToken;
          })
        };
      }, _this2.handleUpdate);
    }, _this2.isValidSelection = function (startToken, endToken) {
      if (isNaN(startToken) || isNaN(endToken)) return false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this2.state.selected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref10 = _step.value;
          var start = _ref10.start,
              end = _ref10.end,
              disabled = _ref10.disabled;

          if (disabled || Math.max(start, startToken) <= Math.min(end, endToken)) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"]) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }, _this2.getTokens = function () {
      var tokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return tokens.map(function (_ref11) {
        var text = _ref11.text,
            id = _ref11.id,
            disabled = _ref11.disabled,
            _ref11$ws = _ref11.ws,
            ws = _ref11$ws === undefined ? true : _ref11$ws;
        return _react2["default"].createElement(Token, {
          key: id,
          text: text,
          id: id,
          disabled: disabled,
          ws: ws,
          honorWs: _this2.props.config.honorTokenWhitespace,
          hideNewlines: _this2.props.config.hideNewlines,
          allowNewlineHighlight: _this2.props.config.allowNewlineHighlight
        });
      });
    }, _this2.getEntity = function (tokens, label, id) {
      return _react2["default"].createElement(_shared.Mark, {
        key: 'ent-' + id,
        classes: {
          _root: _this2.props.classes.mark
        },
        label: label,
        onClick: function onClick(ev) {
          return _this2.handleDeletion(tokens);
        },
        color: _this2.props.config.labelColors[label],
        writingDir: _this2.props.config.writingDir
      }, tokens.map(function (_ref12) {
        var _React$createElement;

        var text = _ref12.text,
            id = _ref12.id,
            ws = _ref12.ws;
        return _react2["default"].createElement(Token, (_React$createElement = {
          key: id,
          text: id
        }, _defineProperty(_React$createElement, 'text', text), _defineProperty(_React$createElement, 'ws', ws), _defineProperty(_React$createElement, 'hideNewlines', _this2.props.config.hideNewlines), _defineProperty(_React$createElement, 'honorWs', _this2.props.config.honorTokenWhitespace), _React$createElement));
      }), _react2["default"].createElement(_shared.Label, {
        writingDir: _this2.props.config.writingDir
      }, label, _react2["default"].createElement('span', {
        className: _this2.props.classes.remove
      }, '\xD7')));
    }, _this2.renderTokens = function (_ref13) {
      var _Array;

      var _ref13$tokens = _ref13.tokens,
          tokens = _ref13$tokens === undefined ? [] : _ref13$tokens,
          _ref13$spans = _ref13.spans,
          spans = _ref13$spans === undefined ? [] : _ref13$spans;

      var selected = _this2.state.selected.sort(function (a, b) {
        return a.start - b.start;
      });

      var offset = 0;
      return (_Array = Array()).concat.apply(_Array, _toConsumableArray(selected.map(function (_ref14, i) {
        var start = _ref14.start,
            end = _ref14.end,
            label = _ref14.label;
        var elements = [].concat(_toConsumableArray(_this2.getTokens(tokens.slice(offset, start))), [_this2.getEntity(tokens.slice(start, end + 1), label, i)]);
        offset = end + 1;
        return elements;
      }))).concat(_this2.getTokens(tokens.slice(offset, tokens.length))).map(function (span) {
        return span;
      });
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(SpansManual, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          content = _props2.content,
          config = _props2.config,
          classes = _props2.classes,
          children = _props2.children;
      var labels = config.labels,
          labelStyle = config.labelStyle,
          manualHighlight = config.manualHighlight,
          cardStyle = config.cardStyle,
          writingDir = config.writingDir;
      var LabelComponent = labelStyle == 'dropdown' ? _LabelDropdown2["default"] : _LabelList2["default"];
      var entClassNames = (0, _classnames2["default"])(classes.entities, _defineProperty({}, classes.rtl, writingDir == 'rtl'));

      var manualButton = _react2["default"].createElement('button', {
        className: classes.addButton,
        onClick: this.handleSelection
      }, _react2["default"].createElement(_Icon2["default"], {
        name: 'plus'
      }));

      return _react2["default"].createElement('div', {
        className: classes.root
      }, _react2["default"].createElement(_shared.Heading, {
        classes: {
          _root: classes.heading
        },
        hasLabels: true
      }, _react2["default"].createElement(LabelComponent, {
        labels: labels,
        selected: this.state.label,
        handleSelect: function handleSelect(label) {
          return _this3.setState({
            label: label
          });
        },
        keymap: config.labelKeymap
      }), manualHighlight && manualButton), _react2["default"].createElement(_shared.Content, _defineProperty({
        nowrap: true,
        cardStyle: cardStyle,
        onMouseUp: !manualHighlight && this.handleSelection,
        onTouchEnd: this.handleSelection,
        onTouchStart: this.handleTouchStart
      }, 'onTouchEnd', this.handleTouchEnd), _react2["default"].createElement('div', {
        className: entClassNames
      }, this.renderTokens(content))), children);
    }
  }]);

  return SpansManual;
}(_react2["default"].Component), _class3.id = 'ner_manual', _temp2)) || _class2);
exports["default"] = SpansManual;